// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"1959e22b","380":"3c38fcdf","625":"d0c5bf3d","683":"4baf38e2","936":"881f8c1e"}[chunkId] + ".chunk.css";
};